import { isNil, mergeWith, omitBy } from 'lodash';
import { defaultVariant } from '../login-variants';
import { LoginVariantProps } from '../interfaces/loginVariant';

export const getLoginVariant = (variants: LoginVariantProps[], onboardingOrigin: string): LoginVariantProps => {
  const activeVariants = variants.filter((variant) => {
    if (variant.publishDate && variant.removalDate) {
      const currentDate = new Date();
      const publishDate = new Date(variant.publishDate);
      const removalDate = new Date(variant.removalDate);
      return currentDate >= publishDate && currentDate <= removalDate;
    } else {
      return variant;
    }
  });

  const matchedVariant = activeVariants.find((variant) => variant.onboarding_origin === onboardingOrigin);

  if (matchedVariant) {
    return mergeWith({}, defaultVariant, omitBy(matchedVariant, isNil));
  }

  const totalWeight = activeVariants.reduce((prev, curr) => {
    return prev + Number(curr.weight || 0);
  }, 0);

  let variant: LoginVariantProps | null = null;

  const threshold = totalWeight * Math.random();

  let weightedSum = 0;
  for (const variantItem of activeVariants) {
    weightedSum += Number(variantItem.weight);
    if (weightedSum >= threshold) {
      variant = variantItem;
      break;
    }
  }

  if (!variant) {
    variant = variants[activeVariants.length - 1];
  }

  return mergeWith({}, defaultVariant, omitBy(variant, isNil));
};
